import { render, staticRenderFns } from "./AllocationUnits.vue?vue&type=template&id=6cec5778&scoped=true&"
import script from "./AllocationUnits.vue?vue&type=script&lang=js&"
export * from "./AllocationUnits.vue?vue&type=script&lang=js&"
import style0 from "./AllocationUnits.vue?vue&type=style&index=0&id=6cec5778&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec5778",
  null
  
)

export default component.exports